import { useQuery } from "@tanstack/react-query";
import { useDependencies } from "src/apps/hooks/useDependencies";
import { useDocumentationAreaIdAndActorId } from "./useDocumentationAreaIdAndActorId";
import { useSearchParams } from "./useSearchParams";
import { useAuth } from "src/apps/hooks/useAuth";
import { useLocale } from "./useLocale";

export type i18nParams = Record<string, string | undefined>;

export const useGetTranslations = () => {
  const { translationController } = useDependencies();
  const { locale } = useLocale();
  const { slug, linkType } = useSearchParams();
  const { documentationAreaId } = useDocumentationAreaIdAndActorId();
  const { token } = useAuth();

  const queryFn = async () => {
    if (!locale) {
      throw new Error("Locale can't be undefined.");
    }

    if (slug && linkType) {
      return await translationController.getTranslation(locale, slug, linkType.getValue());
    }

    if (!documentationAreaId) {
      throw new Error("documentationAreaId shouldn't be undefined.");
    }

    const result = await translationController.getTranslationByDocumentationAreaId(
      locale,
      documentationAreaId,
      token,
    );
    return result;
  };

  const { isLoading, data, error } = useQuery({
    queryKey: ["translations", locale],
    queryFn,

    /* refetchOnMount: false -> This could potentially fix an issue 
    related with the translations being refetched every UploaderBox
    component focus but could give us other issues */
    refetchOnMount: false,
    retry: false,
    enabled: Boolean(locale),
  });

  return { isLoading, error, data };
};
